import PropTypes from "prop-types";
import React, { Component } from "react";
import "./downloadToggle.css";

export default class DownloadToggle extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    window.rawData = this.props.selected
    const { selected, toggleSelected } = this.props;
    return (
      <div className="toggle-main2">
        <div className="rawtext2">Vehicles</div>
        <div className="toggle-container2" onClick={toggleSelected}>
            <div className={`dialog-button2 ${selected ? "" : "disabled2"}`}>
            {selected ? "" : ""}
            </div>
        </div>
      </div>
    );
  }
}

